/**************************************************
 * Nombre:       Tarjeta_Cripto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import QRCode from 'react-qr-code';
import {ContentCopy} from '@mui/icons-material'

const Tarjeta_Cripto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: 14, fontWeight: 300}}>{item.tipo}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -0.5}}>
                <Typography sx={{fontSize: 20, fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -4}}>
                <QRCode value={item.direccion} />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{
                        wordBreak: 'break-word', // O 'break-all' para forzar el corte en cualquier punto
                        overflowWrap: 'anywhere',
                        textAlign: 'center',
                        height: 100
                    }}
                >{item.direccion}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Button variant={'outlined'} startIcon={<ContentCopy/>} > Copiar</Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Cripto    